import React, { Component, PropTypes } from 'react';
import { browserHistory } from 'react-router';
import { saveCurrentRoute } from '../../util/routeHelper';
import { INTEGRATED_SURVEY, INTEGRATED_SURVEY_Q3 } from '../constants/bookingConstants';
import Survey from 'bambora-survey';

class BookingWizardConfirmIntegratedDetails extends Component {

    constructor(props) {
        super(props);

        this.state = { requirementsConfirmed: false };
    }

    handleYes() {
        this.setState({ requirementsConfirmed: true });
    }

    handleNo() {
        let {jobId} = this.props.routeParams;
        saveCurrentRoute(this.props.location.pathname);

        browserHistory.push(`/contactus/incorrectdetails/${jobId}`);
    }

    handleSurveySubmit(values) {
        const newLine =  "\r\n";

        let notes = "Integrated Site Checklist: " + newLine + 
                    "Connection Method: " + values.connectionMethod + newLine +
                    "Keyboard/Mouse: " + values.hasKeyboardOrMouse + newLine +
                    "External IT Support: " + values.hasExternalITSupport + newLine +
                    "Site Setup: " + values.siteSetup + newLine +
                    "Operating System: " + values.operatingSystem;

        this.props.onBookingDataSelection("notesIntegratedSurvey", notes);
        this.props.onSubmit();
    }


    display_Intergrated_Survey_Q3(client, deviceType) {

      if (client == 'NAB') {
        if (deviceType == 'MOVE5000CLOUD' || deviceType == 'MOVE5000POS') {
          return true;
        }
      }

      return false;
    }

    displayPCEftpos_LinklyCodes(client, deviceType) {
      if (client == 'NAB') {
        if (deviceType == 'MOVE5000POS') {
          return false;
        }
      }

      return true;
    }

  render() {
    const { booking: { jobinfo } } = this.props;
    console.log(jobinfo);

      if (this.state.requirementsConfirmed) {

        if (this.display_Intergrated_Survey_Q3(jobinfo.clientID, jobinfo.deviceType) == true) {
          return (
            <Survey
              {...INTEGRATED_SURVEY_Q3}
              onSubmit={this.handleSurveySubmit.bind(this)}
              autoSubmit={false}
            />
          );
        }
        else {
          return (
            <Survey
              {...INTEGRATED_SURVEY}
              onSubmit={this.handleSurveySubmit.bind(this)}
              autoSubmit={false}
            />
          );
        }
      }

        return (
            <div>
                <h2 className="client-text">Does your site have the following?</h2>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card text-center">
                            <p><i className="fa fa-credit-card" /> A working POS.</p>
                            <p><i className="fa fa-wifi" /> An active Internet Connection.</p>
                            {this.displayPCEftpos_LinklyCodes(jobinfo.clientID, jobinfo.deviceType) ? 
                              (<p className="pc-eftpos">
                                <i className="fa fa-asterisk" /> PC Eftpos Codes.
                              </p>) : (null)}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6">
                        <button type="button" className="btn btn-client btn-lg btn-block" onClick={this.handleYes.bind(this)}>
                            Yes
                        </button>
                    </div>
                    <div className="col-xs-6">
                        <button type="button" className="btn btn-lg btn-block btn-client-alt" onClick={this.handleNo.bind(this)}>
                            No
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default BookingWizardConfirmIntegratedDetails;



// WEBPACK FOOTER //
// ./app/booking/components/bookingWizardConfirmIntegratedDetails.js